const normalizeBaseUrl = (value = '') => value.replace(/\/+$/, '');

export const API_BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_API_BASE_URL || '',
);

export const PAID_TIER_LABEL = 'Premium';

export const getPlanLabel = isPremium =>
  Number(isPremium) >= 1 ? 'Premium' : 'Free';

export const isPaidUser = isPremium => Number(isPremium) >= 1;
